import React from 'react'
import { useTranslation } from 'react-i18next'
import camelCase from 'camelcase'

import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

export type MainFloorSpaceFieldAdditionalProps = {
  mainFloorType: MainFloorType
}

export enum MainFloorType {
  AREA = 'AREA',
  STORAGE_AND_PRODUCTION_AREA = 'STORAGE_AND_PRODUCTION_AREA',
  GASTRONOMY_AREA = 'GASTRONOMY_AREA',
  STORE_AREA = 'STORE_AREA',
  RENTAL_AREA = 'RENTAL_AREA',
}

const MainFloorSpaceField: React.FC<
  FieldProps<BasicInfoScreenValidationResult> & MainFloorSpaceFieldAdditionalProps
> = ({ screenName, insertionData, validationMessages, mainFloorType, onChange }) => {
  const { t } = useTranslation()
  return (
    <TextInput
      id='main-floor-space'
      propertyName='mainFloorSpace'
      placeholder=''
      label={<span>{t(`wizard.screen.basicInfo.mainFloorSpace.${camelCase(mainFloorType)}`, 'Main floor space')}</span>}
      value={insertionData.mainFloorSpace}
      maxLength={12}
      type='text'
      affixRight='unit'
      unitRight='sqm'
      errors={validationMessages?.mainFloorSpace ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  )
}

export default MainFloorSpaceField
